import './modal-material.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment';
import { useRef, useState, useEffect } from 'react';

export default function ModalMaterial(props) {

    const contentEl = useRef(null);
    const [contentHeight, setContentHeight] = useState(0)


    useEffect(() => {
        if(contentEl.current){
            setContentHeight(contentEl.current.clientHeight)
        }
        
    }, [props.open])

    return (
        <div className={'modal-material ' + (props.open ? 'open' : '')}>
            {props.material && props.open &&
                <div className='modal-material-content flex flex-col'>
                    <div className='modal-material-header flex'>
                        <div className='grow'>
                            <h1 className='heading-h6 !text-white uppercase'>{props.material.titulo}</h1>
                            <p className='text-secundary mt-2'>{moment(props.material.createdAt).format("DD/MM/YYYY")}</p>
                        </div>

                        <button className='btn-close ' onClick={props.onClose}>
                            <FontAwesomeIcon icon={faClose} />
                        </button>

                    </div>
                    <div className='modal-material-body grow self-center w-full my-5' ref={contentEl}>

                        {props.material.tipo === 'VIDEO' &&
                            <>
                                <div className='center'>
                                    <video controls controlsList="nodownload" className='w-auto' style={{ 'height': `${contentHeight}px`}}>
                                        <source src={props.material.url} />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </>
                        }
                        {props.material.tipo === 'AUDIO' &&
                            <>
                                <div className='center'>
                                    <audio controls controlsList="nodownload">
                                        <source src={props.material.url} />
                                        Your browser does not support the audio element.
                                    </audio>
                                </div>
                            </>
                        }
                        {props.material.tipo === 'IMAGEN' &&
                            <>
                                <div className='center' style={{ 'maxHeight': `${contentHeight}px`}}>
                                    <img src={props.material.url} alt={props.material.titulo} className='w-auto m-auto'   style={{ 'maxHeight': `${contentHeight}px`}}/>
                                </div>
                            </>
                        }


                    </div>
                    {/* <div className='modal-material-footer text-center'>
                        {props.material.tipo == 'IMAGEN' &&
                            <p className='text-white'>UNA OPCION</p>
                        }
                    </div> */}
                </div>
            }

        </div>
    );
}
